





























































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { QuestionCategory } from '@/utils/constants'

import {
  Label as FormItemLabel,
  ReferenceImages,
  ImageType,
  InputText,
  InputList,
  InputFile,
  ConfirmAnswer
} from './components'

type ChildType = {
  id: string
  optionId: string
  title: string
  required: boolean
  description?: string
  type: QuestionCategory
  image?: ImageType[]
  options?: OptionItemType
}
type OptionItemType = {
  id: string
  image?: string
  value: string
  name: string
  children_questions?: ChildType[]
}
type ValueType = string | string[] | File[]

@Component({
  components: {
    FormItemLabel,
    ReferenceImages,
    InputText,
    InputList,
    InputFile,
    ConfirmAnswer
  }
})
export default class FormItem extends Vue {
  @Prop({ required: true, default: null }) private value!: ValueType

  @Prop({ required: false, default: null }) private childValues!: {
    [key: number]: Array<{
      childValue: ValueType
    }>
  }

  @Prop({ required: true, default: '' }) private id!: string
  @Prop({ required: true, default: '' }) private title!: string
  @Prop({ required: false, default: '' }) private description!: string
  @Prop({ required: false, default: [] }) private images!: ImageType[]
  @Prop({ required: true, default: false }) private required!: boolean
  /** text, long_text, checkbox, radio, condition_question  */
  @Prop({ required: true, default: QuestionCategory.Text })
  private type!: QuestionCategory

  @Prop({ required: false, default: [] }) private options!: OptionItemType[]
  @Prop({ required: true, default: false }) private isConfirm!: boolean
  @Prop({ required: true, default: false }) private hasError!: boolean
  @Prop({ required: true, default: false }) private hasChildError!: boolean

  private localChildValues: {
    [key: string]: Array<{ childValue: ValueType }>
  } = {}

  mounted() {
    this.localChildValues = { ...this.childValues }
  }

  private get eventNameChange(): string {
    return 'change'
  }

  private get eventNameChildChange(): string {
    return 'child-change'
  }

  private get localValue(): Array<{ childValue: ValueType }> {
    return this.selectedOption
      ? this.localChildValues[this.selectedOption?.id]
      : []
  }

  private get questionCategories() {
    return QuestionCategory
  }

  private get singleValue() {
    return this.value || ''
  }

  private set singleValue(value) {
    this.$emit(this.eventNameChange, value)
  }

  private get multiValue() {
    return this.value || []
  }

  private set multiValue(value) {
    this.$emit(this.eventNameChange, value)
  }

  private getLocalValue(index: number, type: string) {
    if (
      type === this.questionCategories.Text ||
      type === this.questionCategories.LongText ||
      type === this.questionCategories.Radio
    ) {
      return this.localValue?.[index]?.childValue || ''
    } else {
      return this.localValue[index]?.childValue || []
    }
  }

  private onChildValuesChange(newVal: ValueType, index: number) {
    this.localValue[index].childValue = newVal
    this.$emit(
      this.eventNameChildChange,
      newVal,
      this.selectedOption?.id,
      index
    )
  }

  @Watch('childValues', { immediate: true })
  private childValuesChange() {
    this.localChildValues = { ...this.childValues }
  }

  private get selectedOption() {
    const option = this.options.find(opt => opt.value === this.value)
    return option || null
  }

  private get childItems() {
    if (!this.selectedOption) return null
    return (
      this.selectedOption.children_questions?.filter(
        c => c.optionId === this.selectedOption!.id
      ) || null
    )
  }
}
